import { createContext, useContext, useReducer } from "react";
import * as React from 'react'
import { GlobalState } from "../types/GlobalState";

/** グローバルステートの初期値 */
const initialState: GlobalState = {
  mail: {
    tenantId: '2c22f4c7-6c9f-4751-90a0-1e3b657fc8fb',
    clientId: '16ba8712-a374-4c9a-a87b-2b493ee37a1b',
    clientSecret: 'qsC8Q~S2c_BhSTpYymGJCoAkGmsQUJjSngk3.bu~',
    tokenAddress: 'https://graph.microsoft.com/.default',
    toAddress: 'noreply@suprime.co.jp'
  },
  alert: {
    isOpen: false,
    severity: 'info',
    message: null,
    autoHideDuration: 6000,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  },
  dialog: {
    isOpen: false,
    title: null,
    content: null,
    submitLabel: '',
    cancelLabel: '',
    submitProcess: () => { }
  }
}

// グローバルステイトの初期値を引数として取り、state用のcontextを生成
const stateContext = createContext(initialState)
// IAction型の引数を取る空の関数を初期値とし、dispatch用のcontextを生成
const dispatchContext = createContext((() => true) as React.Dispatch<GlobalState>)

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function AppContext(props: Props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <dispatchContext.Provider value={dispatch}> {/* dispatch用contextにdispatchを設置 */}
      <stateContext.Provider value={state}> {/* state用contextにstateを設置 */}
        {props.children}
      </stateContext.Provider>
    </dispatchContext.Provider>
  )
}

/** グローバルステート呼び出し */
export const useGlobalState = () => {
  return {
    state: useContext(stateContext),
    setState: useContext(dispatchContext)
  }
}

/** 受け取った値を返却 */
const reducer = (oldValue: GlobalState, newValue: GlobalState) => {
  return newValue
}
